import { GET_PAYMENTS_LIST } from './terminal.actionsTypes';

export default function terminal(state = {}, action) {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case GET_PAYMENTS_LIST:
            return {
                ...newState,
                paymentsList: action.paymentsList
            }
        default:
            return newState;
    }
}